import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LanguageReadyService } from '../../../services/language-ready';

@Component({
  selector: 'app-lang-gate',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (langReady.ready()) {
      <ng-content />
    } @else {
      <ng-content select="[skeleton]" />
    }
  `,
  styles: ':host { display: contents; }',
})
export class LangGateComponent {
  protected readonly langReady = inject(LanguageReadyService);
}
